
import { Component, Inject, Vue } from 'vue-property-decorator';
import GlossSearchBar from '@/ui/GlossSearchBar.vue';
import GlossRepository from '@/api/GlossRepository';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BeforeDestroyAware, CreatedAware } from '@/util/lifecycle';
import { filter, switchMap } from 'rxjs/operators';
import GlossMediaOverview from '@/api/graph/GlossMediaOverview';
import GlossSearchResult from '@/api/graph/GlossSearchResult';
import GlossMediaDisplay from '@/ui/GlossMediaDisplay.vue';

@Component({
    components: {
        GlossSearchBar,
        GlossMediaDisplay,
    },
})
export default class SelectionPane extends Vue implements CreatedAware, BeforeDestroyAware {
    public loading = false;
    public mediaCategories = ['drawings', 'pictograms', 'photos'];
    public mediaOverview: GlossMediaOverview = {
        name: '',
        pictograms: [],
        photos: [],
        drawings: [],
    };
    public activeDragId: string | null = null;

    @Inject()
    private glossRepository!: GlossRepository;
    private glossIdForMediaSubject = new BehaviorSubject('');
    private glossMediaSubscription = new Subscription();

    public created(): void {
        this.glossMediaSubscription = this.glossIdForMediaSubject
            .pipe(
                filter((id) => id.length > 0),
                switchMap((id) => this.glossRepository.findGlossMediaById(id)),
            )
            .subscribe((resource) => {
                this.loading = resource.isLoading;
                if (resource.hasData()) {
                    this.mediaOverview = resource.data;
                }
            });
    }

    public beforeDestroy(): void {
        this.glossMediaSubscription.unsubscribe();
    }

    public onGlossSelected(gloss: GlossSearchResult) {
        this.glossIdForMediaSubject.next(gloss.id);
    }

    public onDragStart(id: string): void {
        this.activeDragId = id;
    }

    public onDragEnd(): void {
        this.activeDragId = null;
    }
}
